<template>
  <el-dialog
    :visible="visible"
    title="删除应用"
    width="400px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="delete-tip">
      <span class="el-icon-warning" style="color: #f56c6c; font-size: 24px; margin-right: 10px;"></span>
      <span>确定要删除应用 "{{ form.appName }}"（商家：{{ form.storeName }}）吗？</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="danger" @click="handleSubmit">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteOpenApiApp } from '@/api/system/openApiAuthApi'

export default {
  name: 'DeleteOpenApiApp',
  data() {
    return {
      visible: false,
      form: {
        appId: '',
        appName: '',
        storeName: ''
      }
    }
  },
  methods: {
    open(app) {
      this.form = {
        appId: app.appId,
        appName: app.appName,
        storeName: app.storeName || ''
      }
      this.visible = true
    },
    async handleSubmit() {
      try {
        const response = await deleteOpenApiApp({ appId: this.form.appId })
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.$emit('success')
          this.visible = false
        } else {
          this.$message.error(response.msg || '删除失败')
        }
      } catch (error) {
        this.$message.error('删除失败')
      }
    },
    handleClose() {
      this.visible = false
      this.form = {
        appId: '',
        appName: ''
      }
    }
  }
}
</script>

<style scoped>
.delete-tip {
  padding: 20px;
  text-align: center;
  font-size: 14px;
  color: #606266;
}
</style>